import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import AppColor from 'utilities/AppColor';
import classNames from "classnames";
// import { useMedia } from 'react-use';
import SwipeableViews from 'react-swipeable-views';
// import AppUtil from 'utilities/AppUtil';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-prevent-tabpanel-${index}`}
      aria-labelledby={`scrollable-prevent-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `scrollable-prevent-tab-${index}`,
    'aria-controls': `scrollable-prevent-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    borderRadius: 17,

  },
  activeTab: {
    color: AppColor.mainColor,
    fontWeight: "bold",
    borderBottom: `2px solid ${AppColor.mainColor}`,
    // borderRight: '2px solid #fff'
  },
  tabs: {
    minHeight: 43,
    color: AppColor.black,
    "& :last-child": {
      margin: 0,
    },
    "& .MuiTab-textColorInherit": {
      opacity: 1,
    },
    "& .PrivateTabIndicator-colorSecondary": {
      display: 'none'
    },
    "& .MuiTabs-indicator": {
      display: 'none'
    },
    "& .MuiTabs-flexContainer": {
      backgroundColor: '#fff',
      "& .MuiAppBar-colorPrimary": {
        backgroundColor: '#fff'
      },
    },
    "& .MuiTabs-scrollable": {
      backgroundColor: '#fff'
    },
    "& .MuiBox-root": {
      padding: 0,
    }
  },
  tab: {
    borderTopRightRadius: 2,
    borderTopLeftRadius: 2,
    backgroundColor: AppColor.greyLighten,
    marginRight: '0.25rem',
    // fontSize: 18,
    textTransform: "unset",
    fontFamily: "Popin, san-serif",
    minHeight: 43,
  },
  swipeable: {
    "& .MuiBox-root": {
      marginTop: 15,
      padding: 0,
    }
  }

}));

export default function ScrollableTabs(props) {
  const { tabs, onChangeTab, activeTab, swipeable, isFullWidth, handleCheckProgress, backStep, setBackStep } = props;
  const classes = useStyles();
  const theme = useTheme();
  // const below768 = useMedia('(max-width: 950px)');
  const [value, setValue] = useState(0);
  // const isMobile = AppUtil.mobileAndTabletCheck();

  const handleChange = (event, newValue) => {
    setValue(newValue);
    handleCheckProgress && handleCheckProgress(newValue);
    onChangeTab && onChangeTab(newValue);
  };

  const handleChangeIndex = (index) => {
    onChangeTab ? onChangeTab(index) : setValue(index);
  };

  useEffect(() => {
    (activeTab || activeTab === 0) && setValue(activeTab);
  }, [activeTab]);

  useEffect(() => {
    if (backStep) {
      setValue(activeTab);
      setBackStep(false);
    }
  }, [backStep, activeTab]);

  return (
    <div className={classes.root}>
      <AppBar position="static">
        <Tabs
          value={value}
          onChange={handleChange}
          variant={isFullWidth ? "fullWidth" : "scrollable"}
          scrollButtons="off"
          aria-label="scrollable prevent tabs example"
          className={classes.tabs}
        >
          {tabs.map((item, index) => {
            return (
              <Tab
                key={index}
                label={item.tabLabel}
                className={classNames({
                  [classes.activeTab]: value === index,
                  [classes.tab]: true,
                })}
                disabled={!!item.disabled}
                {...a11yProps(index)} />
            )
          })}
        </Tabs>
      </AppBar>
      <SwipeableViews
        axis={theme.direction === "rtl" ? "x-reverse" : "x"}
        index={value}
        onChangeIndex={handleChangeIndex}
        disabled={!swipeable}
        className={classes.swipeable}
      >
        {tabs.map((item, index) => {
          return (
              <TabPanel key={index} value={value} index={index} dir={theme.direction} >{item.tabContent}</TabPanel>
          )
        })}
      </SwipeableViews>

    </div>
  );
}
ScrollableTabs.propTypes = {
  tabs: PropTypes.any,
  onChangeTab: PropTypes.func,
  swipeable: PropTypes.bool,
  activeTab: PropTypes.any,
  isFullWidth: PropTypes.bool,
  handleCheckProgress: PropTypes.func,
  backStep: PropTypes.bool,
  setBackStep: PropTypes.func,
}